

































































































































import { AuthClient, authClient } from "@/auth0";
import { Component } from "vue-property-decorator";
import { UserAccount } from "@/interfaces/user";
import { mapState } from "vuex";
import Vue from "vue";

@Component({
  components: {
    // UserWidget
  },
  computed: {
    ...mapState(["user"])
  }
})
export default class NavBar extends Vue {
  // Mapped from Vuex
  user!: UserAccount;

  // Other variables
  auth: AuthClient = authClient;

  get isAuthenticated(): boolean {
    return this.user && !!this.user.user_id;
  }

  async login() {
    await authClient.login(`${process.env.VUE_APP_URL}/`);
  }
}
